<template>
    <!-- this version dont have the plus button -->
    <div no-body id="print">
        <b-row class="mx-2">
            <b-col>
                <card> 
                    <div slot="header">
                        <b-row >
                            <b-col cols="6">
                                <h1 class="mb-0">Net Worth Statement</h1>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <base-button type="primary" icon size="sm" @click.prevent="underDevelopment()">
                                    <span class="btn-inner--text">Send KYC To Customer</span>
                                </base-button>
                                <base-button type="primary" icon size="sm" v-b-toggle.collapse-4>
                                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Card body -->
                    <b-collapse id=collapse-4 visible class="mx-6">
                        <div>
                            <h5 class="text-danger"> Note : <br>
                                <i>
                                    1. The blue color value indicated the value filled by customer.
                                </i>
                                <br>
                                <i>
                                    2. The gray color value indicated the value auto calculated by system.
                                </i>
                                <br>
                                <i>
                                    3. If the monthly column is being filled up, the annual value will be auto calculated; Vice versa.
                                </i>
                                <br>
                                <i>
                                    4. Advisory can only edit the column filled up by customer, if monthly column is filled up, advisory can only update the monthly column.
                                </i>
                                <br>
                            </h5>
                            <br>
                            <h2>{{cashIncomes[0].Cust_Info.Cust_Name}}</h2>
                            <table style="margin-bottom:20px">
                                <tr class="text-white">
                                    <th></th>
                                    <th style="width:10%">Customer Answer (RM)</th>
                                    <th style="width:10%">Advisory Answer (RM)</th>
                                </tr>
                                <!-- assets -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="3"><b>Assets - from Advisor Manual Update</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="3"><b>Assets</b></td>
                                    </tr>
                                    <template v-for="(uniqueSubCategory, index) in uniqueSubCategories" >
                                        <tr><td colspan="3" class="pl-4"><b>{{uniqueSubCategory}}</b>&nbsp;
                                            <base-button type="primary" icon size="sm" @click.prevent="underDevelopment()">
                                                <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                            </base-button>
                                        </td></tr>
                                        <template v-for="asset in assets[0].customer_assets" >
                                            <tr :key="asset.answer.answer_id" v-if="asset.customer_template_category.customer_sub_category_name == uniqueSubCategory" >
                                                <td class="pl-5">{{asset.customer_question_column}}</td>
                                                <td>{{asset.answer.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                                <td>
                                                    <el-input type="number" min="0" size="small" id="admin-value" v-model="asset.answer.admin_value"></el-input>
                                                </td>
                                            </tr>
                                        </template>
                                        <tr :key="index">
                                            <td class="pl-4"><b>Total {{uniqueSubCategory}}</b></td>
                                            <td><b>{{assets[0].total.total_asset_customer_value[uniqueSubCategory].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue[uniqueSubCategory].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td><b>Total Assets</b></td>
                                        <td><b>{{assets[0].total.total_asset.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.asset}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <!-- liabilities -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="5"><b>Liabilities - from IM2U</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="5"><b>Liabilities</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" class="pl-4"><b>Current Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses[0].im2u_liabilities">
                                        <tr :key="fixedExpense.loan_statue_name" v-if="fixedExpense.loan_statue != 'HSLNFNCE' && fixedExpense.loan_statue != 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                    <tr>
                                        <td class="pl-4"><b>Total Current Liabilities</b> </td>
                                        <td><b>{{fixedExpenses[0].total_current_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["current"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="5" class="pl-4"><b>Long Term Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses[0].im2u_liabilities" >
                                        <tr :key="fixedExpense.loan_statue_name" v-if="fixedExpense.loan_statue == 'HSLNFNCE' || fixedExpense.loan_statue == 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="pl-4"><b>Total Long Term Liabilities</b> </td>
                                        <td><b>{{fixedExpenses[0].total_long_term_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["long_term"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Liabilities</b> </td>
                                        <td><b>{{(fixedExpenses[0].total_current_liability+fixedExpenses[0].total_long_term_liability).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <tr>
                                    <td><b>Net Worth</b></td>
                                    <td><b>{{(assets[0].total.total_asset - (fixedExpenses[0].total_current_liability+fixedExpenses[0].total_long_term_liability)).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    <td><b></b>{{netWorthAdmin.total.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                </tr>
                            </table> 
                        </div>
                        <el-table class="table-responsive align-items-center table-flush"
                                    header-row-class-name="thead-light"
                                    :data="queriedData"
                                    @sort-change="sortChange"
                                    @selection-change="selectionChange"
                                    highlight-current-row
                                    @current-change="handleCurrentChange"
                                    row-key="id">
                            <el-table-column label="Name"
                                            min-width="100px"
                                            prop="Bank_Name"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Bank_Name}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Estimated Best Rate"
                                            min-width="100px"
                                            prop="Loan_Interest"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{parseFloat(row.Loan_Interest).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Eligibility Amount(RM)"
                                            min-width="100px"
                                            prop="Loan_Eligible"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Loan_Eligible}}</b>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <b-row>
                            <b-col md="4">
                                <base-input label="Banks / Loan Eligibility (RM)">
                                    <el-select v-model="selects.simple" filterable
                                                placeholder="Select Banks">
                                        <el-option v-for="option in cashIncomes[0].Bank_Info"
                                                    :key="option.Bank_Id"
                                                    :label="option.Bank_Code +' / RM '+ option.Loan_Eligible"
                                                    :value="option.Bank_Id">
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </b-col> 
                        </b-row> -->
                        <!-- <div>This Function / Module is currently Under Development, Please come back later.</div> -->
                    </b-collapse>
                    <!-- <b-col class="text-center">
                        <base-button type="primary" icon size="sm" @click.prevent="close()">Back / Close</base-button>
                    </b-col> -->
                </card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { Table, TableColumn, Select , Option } from 'element-ui'
    import axios from 'axios'
    import {apiGatewayDomain, getHeader} from '@/assets/js/config.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import cashIncomes from './cashincomes';
    import fixedExpensesData from './fixedexpenses';
    import customerAssets from './kycassets';
    import {getUserInfo} from '@/assets/js/config.js'

    export default {
        mixins: [notifyFunctionMixin, clientPaginationMixin],
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                loginUser : getUserInfo(),
                cashIncomes,
                fixedExpensesData,
                customerAssets,
                tableData: cashIncomes[0].Bank_Info,
                selectedRows: [],
                selects:{
                    simple:[],
                    template:[]
                },
                uniqueSubCategories: [],
                assetAdminValue: [],
                totalAssetAdminValue: [],
                netWorthAdmin: {
                    asset: 0,
                    liability: 0,
                    total: 0,
                },
                liabilityAdminValue: [],
                totalLiabilityAdminValue: {
                    current: 0,
                    long_term: 0,
                },
            };
        },
        created() {
            this.initialAsset();
            // below code needed to run the computed and watch on created
            this.customerAssets = {...customerAssets};    
            this.fixedExpensesData = {...fixedExpensesData};   
        },
        computed:{
            assets() {
                const {customerAssets} = this
                return customerAssets
            },
            fixedExpenses() {
                const {fixedExpensesData} = this
                return fixedExpensesData
            }
            
        },
        watch: {
            assets: {
                handler: function(val) {
                    let assetAdminValue = this.assetAdminValue
                    let totalAssetAdminValue = this.totalAssetAdminValue;
                    val[0].customer_assets.filter( function( data, idx ) {
                        assetAdminValue[data.customer_template_category.customer_sub_category_name] = {
                            ...assetAdminValue[data.customer_template_category.customer_sub_category_name],
                            [data.answer.answer_id]: parseFloat(data.answer.admin_value)
                        };
                        totalAssetAdminValue[data.customer_template_category.customer_sub_category_name] = 0;
                    });

                    // calculate total admin value for each sub category
                    Object.values(this.uniqueSubCategories).forEach((key) => {
                        Object.values(assetAdminValue[key]).forEach((data) => {
                            if(isNaN(data))
                            {
                               data = 0;
                            }
                            totalAssetAdminValue[key] += data;
                        });
                    });

                    this.getNetWorth();
                },
                deep: true,
            },
            fixedExpenses: {
                handler: function(val) {
                    let liabilityAdminValue = this.liabilityAdminValue
                    let totalLiabilityAdminValue = this.totalLiabilityAdminValue;
                    val[0].im2u_liabilities.filter( function( data, idx ) {
                        if(data.loan_statue == "HSLNFNCE" || data.loan_statue == "PCPASCAR") 
                        {
                            liabilityAdminValue['long_term'] = {
                                ...liabilityAdminValue['long_term'],
                                [data.im2u_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['long_term'] = 0;
                        }
                        else
                        {
                            liabilityAdminValue['current'] = {
                                ...liabilityAdminValue['current'],
                                [data.im2u_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['current'] = 0;
                        }
                    });
                    Object.keys(liabilityAdminValue).forEach((key) => {
                        Object.values(liabilityAdminValue[key]).forEach((data) => {
                            if(isNaN(data))
                            {
                                data = 0;
                            }
                            totalLiabilityAdminValue[key] += data;
                        });                    
                    });     

                    this.getNetWorth();
                },
                deep: true,
            },
        },
        methods: {
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows
            },
            handleCurrentChange(selectedRow){
                console.log(selectedRow);
            },
            close() {
                this.$router.back();
            },
            initialAsset() {
                let uniqueCategory= [];
                let uniqueSubCategory= [];
                let totalAssetAdminValue = [];
                Object.values(customerAssets[0].customer_assets).forEach((data) => {
                    
                    // set category
                    if(uniqueCategory.indexOf(data.customer_template_category.customer_category_name) < 0)
                    {
                        uniqueCategory[data.customer_template_category.customer_category_sort] = data.customer_template_category.customer_category_name;
                    }
                    if(uniqueSubCategory.indexOf(data.customer_template_category.customer_sub_category_name) < 0)
                    {
                        uniqueSubCategory[data.customer_template_category.customer_sub_category_sort] = data.customer_template_category.customer_sub_category_name;
                        totalAssetAdminValue[data.customer_template_category.customer_sub_category_name] = 0;
                    }
                });
                this.uniqueSubCategories = uniqueSubCategory;
                this.totalAssetAdminValue = totalAssetAdminValue;  
 
            },
            getTotalAsset() {
                this.netWorthAdmin.asset = 0;
                Object.values(this.totalAssetAdminValue).forEach((data) => {
                    this.netWorthAdmin.asset += data;
                });
            },
            getTotalLiability() {
                this.netWorthAdmin.liability = 0;
                Object.values(this.totalLiabilityAdminValue).forEach((data) => {
                    this.netWorthAdmin.liability += data;
                });
            },
            getNetWorth() {
                this.getTotalAsset();
                this.getTotalLiability();
                let netWorth = this.netWorthAdmin.asset - this.netWorthAdmin.liability;
                this.netWorthAdmin = {...this.netWorthAdmin, total: netWorth}

                // console.log(this.totalCustomerCommitment);
            },
            onSelectBank(row) {
                console.log(row);
            }
        }
    };
</script>
<style scoped>
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td , th {
    border: 1px solid #dddddd;
    text-align: center;
    /* height: 10px; */
    /* width: 20%; */
}

td:first-child {
    text-align: left;
    padding-left: 8px;
}

th {
    background-color: #525f7f;
    font-size: large;
    width: 20%;
}

.button-right {
    padding-right: 0;
}

</style>
<style>
#admin-value {
    text-align:center;
    font-size:medium;
}
</style>